// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  font-family: Arial, sans-serif;
}

.dashboard-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 2rem;
  border-radius: 12px;
  margin-bottom: 2rem;
}

.dashboard-header h2 {
  margin: 0 0 0.5rem 0;
}

.membership-status {
  margin: 0;
  opacity: 0.9;
}

.payment-required-notice {
  background: #fff3cd;
  border: 2px solid #ffc107;
  border-radius: 12px;
  padding: 2rem;
  text-align: center;
  margin-top: 2rem;
}

.payment-required-notice h2 {
  color: #856404;
  margin-top: 0;
}

.payment-required-notice p {
  color: #856404;
}

/* Welfare Section */
.welfare-section {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 2rem;
}

.welfare-section h3 {
  margin-top: 0;
  color: #333;
  border-bottom: 2px solid #667eea;
  padding-bottom: 0.5rem;
}

.welfare-not-enrolled {
  text-align: center;
  padding: 2rem 0;
}

.welfare-not-enrolled p {
  color: #666;
  margin-bottom: 1.5rem;
}

.join-welfare-btn {
  background: #28a745;
  color: white;
  border: none;
  padding: 0.8rem 2rem;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.3s;
}

.join-welfare-btn:hover {
  background: #218838;
}

.welfare-enrolled {
  display: grid;
  gap: 2rem;
}

.welfare-info {
  background: #f8f9fa;
  padding: 1.5rem;
  border-radius: 8px;
}

.welfare-info p {
  margin: 0.5rem 0;
  color: #333;
}

.welfare-payment-section {
  border-top: 1px solid #ddd;
  padding-top: 1.5rem;
}

.welfare-payment-section h4 {
  margin-top: 0;
  color: #667eea;
}

.welfare-payment-section select {
  width: 100%;
  padding: 0.8rem;
  margin-bottom: 1rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 1rem;
}

/* Payment Form */
.payment-form {
  background: #f8f9fa;
  padding: 1.5rem;
  border-radius: 8px;
  margin-top: 1rem;
}

.payment-form p {
  text-align: center;
  font-size: 1.1rem;
  margin-bottom: 1rem;
}

.card-element-wrapper {
  border: 1px solid #ddd;
  padding: 12px;
  border-radius: 8px;
  background: white;
  margin-bottom: 1rem;
}

.payment-form button {
  width: 100%;
  padding: 0.8rem;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.3s;
}

.payment-form button:hover {
  background: #5568d3;
}

.payment-form button:disabled {
  background: #ccc;
  cursor: not-allowed;
}

/* Opportunities Section */
.opportunities-section {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.opportunities-section h3 {
  margin-top: 0;
  color: #333;
  border-bottom: 2px solid #667eea;
  padding-bottom: 0.5rem;
  margin-bottom: 1.5rem;
}

.post-opportunity-btn {
  background: #007bff;
  color: white;
  border: none;
  padding: 0.8rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  margin-bottom: 1.5rem;
  transition: background 0.3s;
}

.post-opportunity-btn:hover {
  background: #0056b3;
}

.opportunities-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
}

.no-opportunities {
  text-align: center;
  color: #666;
  padding: 2rem;
  background: #f8f9fa;
  border-radius: 8px;
}

.opportunity-card {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s, box-shadow 0.2s;
}

.opportunity-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.opportunity-card h4 {
  margin-top: 0;
  color: #333;
}

.opportunity-card p {
  margin: 0.5rem 0;
  color: #666;
}

.card-actions {
  display: flex;
  gap: 0.5rem;
  margin-top: 1rem;
}

.card-actions button {
  flex: 1 1;
  padding: 0.6rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.3s;
}

.card-actions button:first-child {
  background: #ffc107;
  color: #333;
}

.card-actions button:first-child:hover {
  background: #e0a800;
}

.delete-btn {
  background: #dc3545 !important;
  color: white !important;
}

.delete-btn:hover {
  background: #c82333 !important;
}

/* Modals */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.welfare-modal,
.opportunity-modal {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
}

.welfare-enrollment-form h3,
.opportunity-modal h3 {
  margin-top: 0;
  color: #333;
  border-bottom: 2px solid #667eea;
  padding-bottom: 0.5rem;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: bold;
  color: #333;
}

.welfare-enrollment-form select,
.welfare-enrollment-form input,
.opportunity-form select,
.opportunity-form input,
.opportunity-form textarea {
  width: 100%;
  padding: 0.8rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 1rem;
  box-sizing: border-box;
  margin-bottom: 1rem;
}

.opportunity-form textarea {
  min-height: 100px;
  resize: vertical;
}

.form-actions {
  display: flex;
  gap: 0.5rem;
  margin-top: 1.5rem;
}

.form-actions button {
  flex: 1 1;
  padding: 0.8rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  transition: background 0.3s;
}

.form-actions button[type="submit"] {
  background: #28a745;
  color: white;
}

.form-actions button[type="submit"]:hover {
  background: #218838;
}

.form-actions button[type="submit"]:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.cancel-btn {
  background: #6c757d !important;
  color: white !important;
}

.cancel-btn:hover {
  background: #5a6268 !important;
}

/* Responsive Design */
@media (max-width: 768px) {
  .dashboard-container {
    padding: 1rem;
  }

  .dashboard-header {
    padding: 1.5rem;
  }

  .opportunities-grid {
    grid-template-columns: 1fr;
  }

  .welfare-modal,
  .opportunity-modal {
    width: 95%;
    padding: 1.5rem;
  }
}
/* ── Attendees Report ── */
.attendees-report {
  margin-top: 2rem;
  border-top: 2px solid #00703C;
  padding-top: 1.5rem;
}

.report-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1.2rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.report-header h3 {
  font-size: 1.2rem;
  color: #1a1a2e;
  margin: 0 0 0.25rem;
}

.report-summary {
  font-size: 13px;
  color: #666;
  margin: 0;
}

.report-loading {
  color: #888;
  font-style: italic;
  padding: 1rem 0;
}

.download-all-btn {
  background: #00703C;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 0.6rem 1.2rem;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s;
}

.download-all-btn:hover { background: #005a30; }

/* Event cards */
.report-event-card {
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  margin-bottom: 1rem;
  overflow: hidden;
}

.report-event-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.85rem 1.2rem;
  background: #f8f9fa;
  cursor: pointer;
  gap: 1rem;
  flex-wrap: wrap;
}

.report-event-header:hover { background: #f0f7f0; }

.report-event-info {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.report-event-title {
  font-size: 15px;
  font-weight: 700;
  color: #1a1a2e;
}

.report-event-meta {
  font-size: 12px;
  color: #666;
}

.report-event-stats {
  font-size: 12px;
  color: #00703C;
  font-weight: 600;
}

.report-event-actions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-shrink: 0;
}

.download-event-btn {
  background: #fff;
  border: 1.5px solid #00703C;
  color: #00703C;
  border-radius: 6px;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s;
}

.download-event-btn:hover {
  background: #00703C;
  color: #fff;
}

.report-toggle {
  font-size: 12px;
  color: #888;
  white-space: nowrap;
}

/* Event body */
.report-event-body {
  padding: 1rem 1.2rem;
}

.no-attendees {
  color: #aaa;
  font-style: italic;
  font-size: 13px;
}

/* Ticket block */
.report-ticket {
  border: 1px solid #eee;
  border-radius: 8px;
  margin-bottom: 0.75rem;
  overflow: hidden;
}

.report-ticket-header {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 1rem;
  align-items: center;
  padding: 0.6rem 0.9rem;
  background: #f0f7f0;
  font-size: 12px;
  color: #444;
}

.report-ref {
  font-family: monospace;
  font-weight: bold;
  color: #00703C;
  font-size: 13px;
}

.report-package-badge {
  background: #00703C;
  color: #fff;
  border-radius: 10px;
  padding: 1px 10px;
  font-size: 11px;
  font-weight: bold;
}

.report-booker { color: #333; }
.report-amount { color: #007bff; font-weight: 600; margin-left: auto; }

/* Attendees table */
.attendees-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.attendees-table th {
  background: #f8f8f8;
  padding: 6px 10px;
  text-align: left;
  font-size: 11px;
  color: #888;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  border-bottom: 1px solid #eee;
}

.attendees-table td {
  padding: 7px 10px;
  border-bottom: 1px solid #f5f5f5;
  color: #333;
}

.attendees-table tr:last-child td { border-bottom: none; }
.attendees-table tr:hover td { background: #fafff8; }`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gCAAgC;EAChC,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,wCAAwC;EACxC,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,WAAW;AACX;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;;EAEE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,WAAW;EACX,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;AACb;;AAEA;;;;;EAKE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,UAAU;IACV,eAAe;EACjB;AACF;AACA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,0BAA0B,mBAAmB,EAAE;;AAE/C,gBAAgB;AAChB;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,eAAe;AACjB;;AAEA,6BAA6B,mBAAmB,EAAE;;AAElD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA,iBAAiB,WAAW,EAAE;AAC9B,iBAAiB,cAAc,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;;AAEtE,oBAAoB;AACpB;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,WAAW;AACb;;AAEA,oCAAoC,mBAAmB,EAAE;AACzD,+BAA+B,mBAAmB,EAAE","sourcesContent":[".dashboard-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2rem;\n  font-family: Arial, sans-serif;\n}\n\n.dashboard-header {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  padding: 2rem;\n  border-radius: 12px;\n  margin-bottom: 2rem;\n}\n\n.dashboard-header h2 {\n  margin: 0 0 0.5rem 0;\n}\n\n.membership-status {\n  margin: 0;\n  opacity: 0.9;\n}\n\n.payment-required-notice {\n  background: #fff3cd;\n  border: 2px solid #ffc107;\n  border-radius: 12px;\n  padding: 2rem;\n  text-align: center;\n  margin-top: 2rem;\n}\n\n.payment-required-notice h2 {\n  color: #856404;\n  margin-top: 0;\n}\n\n.payment-required-notice p {\n  color: #856404;\n}\n\n/* Welfare Section */\n.welfare-section {\n  background: white;\n  padding: 2rem;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  margin-bottom: 2rem;\n}\n\n.welfare-section h3 {\n  margin-top: 0;\n  color: #333;\n  border-bottom: 2px solid #667eea;\n  padding-bottom: 0.5rem;\n}\n\n.welfare-not-enrolled {\n  text-align: center;\n  padding: 2rem 0;\n}\n\n.welfare-not-enrolled p {\n  color: #666;\n  margin-bottom: 1.5rem;\n}\n\n.join-welfare-btn {\n  background: #28a745;\n  color: white;\n  border: none;\n  padding: 0.8rem 2rem;\n  border-radius: 8px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background 0.3s;\n}\n\n.join-welfare-btn:hover {\n  background: #218838;\n}\n\n.welfare-enrolled {\n  display: grid;\n  gap: 2rem;\n}\n\n.welfare-info {\n  background: #f8f9fa;\n  padding: 1.5rem;\n  border-radius: 8px;\n}\n\n.welfare-info p {\n  margin: 0.5rem 0;\n  color: #333;\n}\n\n.welfare-payment-section {\n  border-top: 1px solid #ddd;\n  padding-top: 1.5rem;\n}\n\n.welfare-payment-section h4 {\n  margin-top: 0;\n  color: #667eea;\n}\n\n.welfare-payment-section select {\n  width: 100%;\n  padding: 0.8rem;\n  margin-bottom: 1rem;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  font-size: 1rem;\n}\n\n/* Payment Form */\n.payment-form {\n  background: #f8f9fa;\n  padding: 1.5rem;\n  border-radius: 8px;\n  margin-top: 1rem;\n}\n\n.payment-form p {\n  text-align: center;\n  font-size: 1.1rem;\n  margin-bottom: 1rem;\n}\n\n.card-element-wrapper {\n  border: 1px solid #ddd;\n  padding: 12px;\n  border-radius: 8px;\n  background: white;\n  margin-bottom: 1rem;\n}\n\n.payment-form button {\n  width: 100%;\n  padding: 0.8rem;\n  background: #667eea;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background 0.3s;\n}\n\n.payment-form button:hover {\n  background: #5568d3;\n}\n\n.payment-form button:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n/* Opportunities Section */\n.opportunities-section {\n  background: white;\n  padding: 2rem;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.opportunities-section h3 {\n  margin-top: 0;\n  color: #333;\n  border-bottom: 2px solid #667eea;\n  padding-bottom: 0.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.post-opportunity-btn {\n  background: #007bff;\n  color: white;\n  border: none;\n  padding: 0.8rem 1.5rem;\n  border-radius: 8px;\n  cursor: pointer;\n  margin-bottom: 1.5rem;\n  transition: background 0.3s;\n}\n\n.post-opportunity-btn:hover {\n  background: #0056b3;\n}\n\n.opportunities-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 1.5rem;\n}\n\n.no-opportunities {\n  text-align: center;\n  color: #666;\n  padding: 2rem;\n  background: #f8f9fa;\n  border-radius: 8px;\n}\n\n.opportunity-card {\n  background: #f8f9fa;\n  border-radius: 8px;\n  padding: 1.5rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: transform 0.2s, box-shadow 0.2s;\n}\n\n.opportunity-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.opportunity-card h4 {\n  margin-top: 0;\n  color: #333;\n}\n\n.opportunity-card p {\n  margin: 0.5rem 0;\n  color: #666;\n}\n\n.card-actions {\n  display: flex;\n  gap: 0.5rem;\n  margin-top: 1rem;\n}\n\n.card-actions button {\n  flex: 1;\n  padding: 0.6rem;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background 0.3s;\n}\n\n.card-actions button:first-child {\n  background: #ffc107;\n  color: #333;\n}\n\n.card-actions button:first-child:hover {\n  background: #e0a800;\n}\n\n.delete-btn {\n  background: #dc3545 !important;\n  color: white !important;\n}\n\n.delete-btn:hover {\n  background: #c82333 !important;\n}\n\n/* Modals */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.welfare-modal,\n.opportunity-modal {\n  background: white;\n  padding: 2rem;\n  border-radius: 12px;\n  width: 90%;\n  max-width: 500px;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.welfare-enrollment-form h3,\n.opportunity-modal h3 {\n  margin-top: 0;\n  color: #333;\n  border-bottom: 2px solid #667eea;\n  padding-bottom: 0.5rem;\n}\n\n.form-group {\n  margin-bottom: 1.5rem;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: bold;\n  color: #333;\n}\n\n.welfare-enrollment-form select,\n.welfare-enrollment-form input,\n.opportunity-form select,\n.opportunity-form input,\n.opportunity-form textarea {\n  width: 100%;\n  padding: 0.8rem;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  font-size: 1rem;\n  box-sizing: border-box;\n  margin-bottom: 1rem;\n}\n\n.opportunity-form textarea {\n  min-height: 100px;\n  resize: vertical;\n}\n\n.form-actions {\n  display: flex;\n  gap: 0.5rem;\n  margin-top: 1.5rem;\n}\n\n.form-actions button {\n  flex: 1;\n  padding: 0.8rem;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 1rem;\n  transition: background 0.3s;\n}\n\n.form-actions button[type=\"submit\"] {\n  background: #28a745;\n  color: white;\n}\n\n.form-actions button[type=\"submit\"]:hover {\n  background: #218838;\n}\n\n.form-actions button[type=\"submit\"]:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n.cancel-btn {\n  background: #6c757d !important;\n  color: white !important;\n}\n\n.cancel-btn:hover {\n  background: #5a6268 !important;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .dashboard-container {\n    padding: 1rem;\n  }\n\n  .dashboard-header {\n    padding: 1.5rem;\n  }\n\n  .opportunities-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .welfare-modal,\n  .opportunity-modal {\n    width: 95%;\n    padding: 1.5rem;\n  }\n}\n/* ── Attendees Report ── */\n.attendees-report {\n  margin-top: 2rem;\n  border-top: 2px solid #00703C;\n  padding-top: 1.5rem;\n}\n\n.report-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 1.2rem;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.report-header h3 {\n  font-size: 1.2rem;\n  color: #1a1a2e;\n  margin: 0 0 0.25rem;\n}\n\n.report-summary {\n  font-size: 13px;\n  color: #666;\n  margin: 0;\n}\n\n.report-loading {\n  color: #888;\n  font-style: italic;\n  padding: 1rem 0;\n}\n\n.download-all-btn {\n  background: #00703C;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  padding: 0.6rem 1.2rem;\n  font-size: 14px;\n  font-weight: bold;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.2s;\n}\n\n.download-all-btn:hover { background: #005a30; }\n\n/* Event cards */\n.report-event-card {\n  border: 1px solid #e0e0e0;\n  border-radius: 10px;\n  margin-bottom: 1rem;\n  overflow: hidden;\n}\n\n.report-event-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.85rem 1.2rem;\n  background: #f8f9fa;\n  cursor: pointer;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.report-event-header:hover { background: #f0f7f0; }\n\n.report-event-info {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.report-event-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: #1a1a2e;\n}\n\n.report-event-meta {\n  font-size: 12px;\n  color: #666;\n}\n\n.report-event-stats {\n  font-size: 12px;\n  color: #00703C;\n  font-weight: 600;\n}\n\n.report-event-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex-shrink: 0;\n}\n\n.download-event-btn {\n  background: #fff;\n  border: 1.5px solid #00703C;\n  color: #00703C;\n  border-radius: 6px;\n  padding: 4px 12px;\n  font-size: 12px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.download-event-btn:hover {\n  background: #00703C;\n  color: #fff;\n}\n\n.report-toggle {\n  font-size: 12px;\n  color: #888;\n  white-space: nowrap;\n}\n\n/* Event body */\n.report-event-body {\n  padding: 1rem 1.2rem;\n}\n\n.no-attendees {\n  color: #aaa;\n  font-style: italic;\n  font-size: 13px;\n}\n\n/* Ticket block */\n.report-ticket {\n  border: 1px solid #eee;\n  border-radius: 8px;\n  margin-bottom: 0.75rem;\n  overflow: hidden;\n}\n\n.report-ticket-header {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem 1rem;\n  align-items: center;\n  padding: 0.6rem 0.9rem;\n  background: #f0f7f0;\n  font-size: 12px;\n  color: #444;\n}\n\n.report-ref {\n  font-family: monospace;\n  font-weight: bold;\n  color: #00703C;\n  font-size: 13px;\n}\n\n.report-package-badge {\n  background: #00703C;\n  color: #fff;\n  border-radius: 10px;\n  padding: 1px 10px;\n  font-size: 11px;\n  font-weight: bold;\n}\n\n.report-booker { color: #333; }\n.report-amount { color: #007bff; font-weight: 600; margin-left: auto; }\n\n/* Attendees table */\n.attendees-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.attendees-table th {\n  background: #f8f8f8;\n  padding: 6px 10px;\n  text-align: left;\n  font-size: 11px;\n  color: #888;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  border-bottom: 1px solid #eee;\n}\n\n.attendees-table td {\n  padding: 7px 10px;\n  border-bottom: 1px solid #f5f5f5;\n  color: #333;\n}\n\n.attendees-table tr:last-child td { border-bottom: none; }\n.attendees-table tr:hover td { background: #fafff8; }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
